import React, { useState } from 'react'
import Table1 from '../../../../components/Common/TableContainer';

// Formik validation
import { Input } from 'reactstrap';

import { BaseCustomButton, GradientDecorationLine, BaseCustomModal } from '../../../../shared';

export const AddPartialReportModal = ({ props, setShowModal, showModal, modalRespInfo, modalHeader, labRequestReportAuxs, total, currentPage, loading, getPagination }) => {

  const { className } = props;
  let [checkedOps, setCheckOp] = useState([])

  const toggle = () => {
    setShowModal(false);
  }

  const onClosed = () => {
    setShowModal(false);
  }

  const onChecked = (val, id) => {
    if(checkedOps?.includes(id)){
      if(!val?.target?.checked){
        const index = checkedOps.indexOf(id);
        if (index > -1) {
          checkedOps.splice(index, 1);
        }
        setCheckOp(checkedOps)
      }
    } else {
      if (val?.target?.checked) {
        checkedOps.push(id)
        setCheckOp(checkedOps)
      }
    }
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'code',
        width: 400,
      },
      {
        Header: 'Informes Parciales',
        accessor: 'name',
        width: 400,
      },
      {
        Header: 'Edad',
        accessor: 'age',
        width: 400,
      },
      {
        Header: 'Fecha de Atención',
        accessor: 'datedAt',
        width: 400,
        Cell: ({ cell: { value } }) => (
          <span>{value ? value.substring(0, 10) : '-'}</span>
        )
      },
      {
        width: '10%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div
            className="page-title-box d-flex align-items-center justify-content-center"
          >
            <Input
              type="checkbox"
              aria-label="..."
              id="checkboxNoLabel"
              defaultChecked={false}
              className="form-check-input rounded-pill p-2"
              onChange={ (values) => onChecked(values, row.original) }
            ></Input>
          </div>
        ),
      },
    ],
    []
  )

  const onSubmit = () =>{
    modalRespInfo(checkedOps)
  }

  const buttons = (
    <div className="page-title-box d-flex justify-content-end">
      <BaseCustomButton
        color='success'
        className='rounded-3 me-2'
        onClick={onSubmit}
        label='Guardar'
        outline={true}
        icon="mdi mdi-content-save me-1"
      />
      <BaseCustomButton
        color='danger'
        className='rounded-3 me-3'
        onClick={toggle}
        label='Cancelar'
        outline={true}
        icon="mdi mdi-close-circle me-1"
      />
    </div>
  );

  const title = (
    <div className='d-flex ms-3 p-0'>
      <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>{modalHeader}</h4></label>
    </div>
  );

  return (
    <>
      <BaseCustomModal
        title={title}
        isModalOpen={showModal}
        handleCancel={toggle}
        onClosed={onClosed}
        centered
        zIndex={9999}
        width="80%"
        className={className}
        footer={buttons}
    >
        <GradientDecorationLine />

        <div className="px-4 mx-3">
            <div className="row p-0 m-0 d-flex align-items-center w-100">
                <div className="col-12 col-md-6 col-lg-10">
                    <input
                        type="search"
                        id="inputSearchData"
                        className="form-control rounded-3"
                        placeholder="Buscar"
                        aria-label="Search"
                    />
                </div>
                <BaseCustomButton
                    color='dark'
                    className='col-12 col-md-6 col-lg-2 rounded-3'
                    onClick={onSubmit}
                    label='Buscar'
                    icon="mdi mdi-magnify me-1"
                />
            </div>

            <div className="px-0 py-2">
                <Table1
                    currentPage={currentPage}
                    loading={loading}
                    getPagination={getPagination}
                    total={total}
                    isAddTableBorderStrap
                    columns={columns}
                    data={labRequestReportAuxs}
                />
            </div>
        </div>

        <GradientDecorationLine />
    </BaseCustomModal>
    </>
  )   
}
